var _ACTION_HANDLERS;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import request from "superagent";
import { instanceUrl, site } from "../utils/cms"; // ------------------------------------
// Constants
// ------------------------------------

export var PAGE_LOADING = "PAGE_LOADING";
export var PAGE_LOADED = "PAGE_LOADED";
var page404 = {
  title: "Siden ble ikke funnet",
  content: '<h3>Siden ble ikke funnet</h3><p>Vennligst kontroller adressen eller <a href="/">gå til hjemmesiden</a>.</p>',
  menu: "[]",
  is404: true
}; // ------------------------------------
// Actions
// ------------------------------------

export function loadPage(uri) {
  return function (dispatch) {
    if (!uri) return;
    dispatch({
      type: "PAGE_LOADING",
      payload: true
    });
    request.post(instanceUrl() + "WebServices/cms/Page.asmx/GetPage").send({
      site: site(),
      uri: uri
    }).set("Accept", "application/json").end(function (err, response) {
      if (err || !response.ok) {
        dispatch({
          type: "PAGE_LOADED",
          payload: {
            page: page404,
            pageLoading: false
          }
        });
        return;
      }

      var res = response.body.d.records[0];

      if (!res) {
        res = page404;
      }

      dispatch({
        type: "PAGE_LOADED",
        payload: {
          page: {
            title: res.title,
            content: res.content,
            menu: res.menu && JSON.parse(res.menu) || [],
            data: res.data && JSON.parse(res.data) || {},
            is404: res.is404 || false
          },
          pageLoading: false
        }
      });
    });
  };
}
export var actions = {
  loadPage: loadPage
}; // ------------------------------------
// Action Handler
// ------------------------------------

var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _ACTION_HANDLERS[PAGE_LOADING] = function (state, action) {
  return _extends({}, state, {
    pageLoading: action.payload,
    page: {
      menu: []
    }
  });
}, _ACTION_HANDLERS[PAGE_LOADED] = function (state, action) {
  return _extends({}, state, {
    pageLoading: action.payload.pageLoading,
    page: action.payload.page
  });
}, _ACTION_HANDLERS); // ------------------------------------
// Reducer
// ------------------------------------

var initialState = {
  pageLoading: false,
  page: {
    title: undefined,
    content: undefined,
    menu: [],
    is404: false
  }
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}